import { ClipboardFormats } from "../desktop/ClipboardFormats";
import { Clipboard } from "../desktop/Clipboard";

export class System {
    public static get totalMemory(): number {
        return 0;
    }

    public static setClipboard(txt: string): void {
        Clipboard.generalClipboard.setData(ClipboardFormats.TEXT_FORMAT, txt);
    }

    public static gc(): void {
    }
}
